<template>
  <div>
    <div class="mt-10">
      <vs-input
        v-model="username"
        v-validate="'required|min:3'"
        class="w-full"
        data-vv-validate-on="blur"
        icon="icon icon-user"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Username" name="username"
        color="white"
        @keyup.enter="loginJWT"/>
      <span class="text-danger text-sm font-bold">{{ errors.first('username') }}</span>
    </div>
    <div class="mt-10">
      <vs-input
        v-model="password"
        v-validate="'required|min:6'"
        class="w-full"
        data-vv-validate-on="blur"
        icon="icon icon-lock"
        icon-no-border
        icon-pack="feather"
        label-placeholder="Password"
        name="password" type="password"
        color="white"
        @keyup.enter="loginJWT"/>
      <span class="text-danger text-sm font-bold">{{ errors.first('password') }}</span>
    </div>
    <!---<div class="flex flex-wrap justify-between my-5">
      <router-link to="/forgot-password">Forgot Password?</router-link>
    </div>--->
    <div class="flex flex-wrap justify-end mt-10">
     <!--- <vs-button type="border" @click="registerUser">Register</vs-button>--->
      <vs-button :disabled="!validateForm || disable" @click="loginJWT" type="border" color="light" id="signInBtn">Sign In</vs-button>
    </div>
<!--    <vs-divider>or</vs-divider>-->
<!--    <div class="flex flex-wrap justify-between mb-3">-->
<!--      <vs-button @click="loginGoogle">Sign-in with Google</vs-button>-->
<!--      <vs-button disabled>Sign-in with Github</vs-button>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      disable: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.username !== '' && this.password !== ''
    }
  },
  methods: {

    checkLogin () {

      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    async loginJWT () {

      if (!this.checkLogin()) return

      // Loading
      this.$vs.loading({
        background: 'white',
        color: 'black',
        container: '#signInBtn',
        scale: 0.45
      })

      this.disabled = true

      const payload = {
        username: this.username,
        password: this.password,
        recaptcha: await this.$recaptcha('user_login_account')
      }


      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => {
          this.$vs.loading.close('#signInBtn> .con-vs-loading')
        })
        .catch(error => {
          this.$vs.loading.close('#signInBtn> .con-vs-loading')
          this.disabled = false

          if (error.response) {

            const response = error.response

            if (response.status === 400 || response.status === 403 || response.status === 404) {

              return this.$vs.notify({
                title: 'Failed to login',
                text: response.data.error.description,
                iconPack: 'feather',
                icon: 'icon-user-x',
                color: 'danger'
              })
            }

            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })

          }

        })
    },
    registerUser () {
      this.$router.push('/register')
    }
  },
  mounted () {
    /* gapi.auth2.init({
      client_id: '433562971754-mcd0svkbb4d12ee1c35i3kq4jdhhbvtp.apps.googleusercontent.com',
    }); */
  }
}

</script>

<style>

.vs-input--input {
  border: 1px solid #fff !important;
  border-radius: 5px;
}

</style>
